import {cn} from '@lib/utils';

interface ScoreCellProps {
  score: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/** Отображает оценку 0–10 с цветовым кодированием (ADR-008). */
export const ScoreCell = ({score, className, size = 'md'}: ScoreCellProps) => {
  const colorClass =
    score >= 8
      ? 'text-[var(--score-good)] bg-[var(--score-good-soft)]'
      : score >= 6
        ? 'text-[var(--score-warn)] bg-[var(--score-warn-soft)]'
        : score >= 4
          ? 'text-[var(--score-default)] bg-[var(--score-default-soft)]'
          : 'text-[var(--score-bad)] bg-[var(--score-bad-soft)]';

  const sizeClass =
    size === 'lg'
      ? 'text-2xl px-3 py-1'
      : size === 'sm'
        ? 'text-xs px-1.5 py-0.5'
        : 'text-sm px-2 py-0.5';

  return (
    <span
      className={cn(
        'inline-flex items-center font-semibold rounded',
        colorClass,
        sizeClass,
        className,
      )}
    >
      {score.toFixed(1)}
    </span>
  );
};
